import type { YieldOpportunity } from '../types'

/**
 * Calculate utilization for a yield opportunity.
 * Returns the utilization ratio (0-1) or undefined if not available.
 */
export function getUtilization(opp: YieldOpportunity): number | undefined {
  if (opp.utilization !== undefined) {
    return opp.utilization
  }

  // EVaults need strategy data to calculate utilization - return undefined if not available
  if (opp.sourceData.type === 'evault') {
    return undefined
  }

  const tvl = opp.tvlUsd?.toNumber() || 0
  if (tvl <= 0) return undefined

  let borrowed = 0
  if (opp.sourceData.type === 'pooled' && opp.sourceData.totalBorrowed) {
    borrowed = opp.sourceData.totalBorrowed.toNumber()
  } else if (opp.sourceData.type === 'elend' && opp.sourceData.totalBorrowedUsd) {
    borrowed = opp.sourceData.totalBorrowedUsd.toNumber()
  } else if (opp.sourceData.type === 'isolated' && opp.sourceData.totalBorrowed) {
    borrowed = opp.sourceData.totalBorrowed.toNumber()
  }

  if (borrowed <= 0) return 0
  return borrowed / tvl
}
